/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AlertModalUpdateMutationVariables = {|
  alert: string,
  slugName: string,
  description?: ?string,
|};
export type AlertModalUpdateMutationResponse = {|
  +warningUpdate: ?{|
    +warning: ?{|
      +id: string,
      +slugName: string,
      +description: string,
      +icon: ?string,
    |}
  |}
|};
export type AlertModalUpdateMutation = {|
  variables: AlertModalUpdateMutationVariables,
  response: AlertModalUpdateMutationResponse,
|};
*/


/*
mutation AlertModalUpdateMutation(
  $alert: ID!
  $slugName: String!
  $description: String
) {
  warningUpdate(input: {id: $alert, slugName: $slugName, description: $description}) {
    warning {
      id
      slugName
      description
      icon
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "alert",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slugName",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "alert"
          },
          {
            "kind": "Variable",
            "name": "slugName",
            "variableName": "slugName"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "WarningUpdatePayload",
    "kind": "LinkedField",
    "name": "warningUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNode",
        "kind": "LinkedField",
        "name": "warning",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slugName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlertModalUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlertModalUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AlertModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AlertModalUpdateMutation(\n  $alert: ID!\n  $slugName: String!\n  $description: String\n) {\n  warningUpdate(input: {id: $alert, slugName: $slugName, description: $description}) {\n    warning {\n      id\n      slugName\n      description\n      icon\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '452fd1fcb6f2ccabd68d6c7bb9641a83';

module.exports = node;
